import { jsx as r } from "react/jsx-runtime";
import o from "next/image";
import a from "@lumirental/lumi-web-shared/lib/constants/lang/LANGUAGES";
const e = ({ language: t }) => t === a.EN ? /* @__PURE__ */ r(
  o,
  {
    src: "/images/svg/arrow-next-icon.svg",
    alt: "Arrow Next",
    width: 16,
    height: 16
  }
) : /* @__PURE__ */ r(
  o,
  {
    src: "/images/svg/arrow-prev-icon.svg",
    alt: "Arrow Previous",
    width: 16,
    height: 16
  }
), m = e;
export {
  m as default
};
